import React, { memo, useCallback, useMemo } from 'react';
import { InputControlLabel } from '@picsio/ui';
import {
  bool, func, shape, string,
} from 'prop-types';
import cn from 'classnames';

const Field = ({
  field, value, onChange, isToriutMedia,
}) => {
  const title = useMemo(
    () => (field.title.startsWith('meta.') ? field.title.replace('meta.', '') : field.title),
    [field.title],
  );
  const handleChange = useCallback(() => onChange(field, !value), [onChange, field, value]);

  return (
    <li key={field?.id} className={cn('title', { checked: value })}>
      <InputControlLabel
        control="checkbox"
        label={title}
        value={value}
        onChange={handleChange}
      />
      <If condition={isToriutMedia}>
        <div className="title-type">
          {field.product ? 'Product' : 'Media'}
        </div>
      </If>
    </li>
  );
};

Field.propTypes = {
  field: shape({
    title: string,
    id: string,
  }).isRequired,
  value: bool,
  onChange: func,
  isToriutMedia: bool,
};

Field.defaultProps = {
  value: false,
  onChange: () => {},
  isToriutMedia: false,
};

export default memo(Field);
